import { Box, Text } from '@ksyos/design-system';
import { styled } from 'styled-components';

export function CircleCountHeading(props: { count?: string; label?: string }) {
    return (
        <Box
            alignItems="center"
            display="flex"
            mb={4}
        >
            <StyledCircle style={{ marginRight: 16 }}>
                <Text
                    as="span"
                    color="primary"
                    fontWeight="bold"
                    size="md"
                >
                    {props.count}
                </Text>
            </StyledCircle>
            <Text
                color="primary"
                fontWeight="medium"
                size="md"
            >
                {props.label}
            </Text>
        </Box>
    );
}

const StyledCircle = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    box-shadow: none;
    padding: 0;
    position: relative;
    border: 1px solid #dbd5d0;
    width: 40px;
    height: 40px;
    flex-shrink: 0;
`;
